import { FieldType } from '@wix/wix-data-schema-types'
import { COLUMN_ROLE } from '@wix/wix-data-client-common-standalone'
import type { DataBindingComponentModel } from '@wix/data-binding-registry-sdk'

const { image, video, text, number, dateTime, date, address, stringArray } =
  FieldType

export default (): DataBindingComponentModel => ({
  componentName: 'Element_Name_Column',
  isConnectGfppEnabled: true,
  supportsDefaultSelectedDataset: true,
  compactErrorPanel: false,
  panel: {
    height: 297,
    title: 'Connect_Panel_Title_Column',
    helpId: 'a481c0b7-3f20-43d0-88e9-44c6c732ed83',
  },
  sections: [
    {
      role: COLUMN_ROLE,
      bindings: [
        {
          title: 'Connect_Panel_Connect_Column_Background_Label',
          prop: 'background.src',
          supportedFieldTypes: [image, video],
          defaultFieldType: image,
          supportsReferenceFields: true,
          requiresPrimaryConnection: true,
        },
        {
          title: 'connectColumnPanel.backgroundAltBinding.title',
          prop: 'background.alt',
          supportedFieldTypes: [
            text,
            number,
            dateTime,
            date,
            address,
            stringArray,
          ],
          defaultFieldType: text,
          supportsReferenceFields: true,
          requiresPrimaryConnection: true,
        },
      ],
      manifest: {
        gfpp: {
          desktop: {
            mainAction2: {
              actionId: 'column_live_preview_gfpp_desktop_main_action',
              label: 'Column_Live_Preview_GFPP_Desktop_Main_Action',
            },
          },
        },
      },
    },
  ],
})
